var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.tickets),function(ticket,index){return _c('QrTicketPrinting',_vm._b({key:index,attrs:{"page-break-after":true}},'QrTicketPrinting',ticket,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }